const SUPPORTED_LANGUAGE_DETAILS = {
  en: { label: 'English', flag: '🇬🇧', key: 'en', numberFormattingLocale: 'en-GB', dayjsLocale: 'en-gb' },
  el: { label: 'Ελληνικά', flag: '🇬🇷', key: 'el', numberFormattingLocale: 'el-GR', dayjsLocale: 'el' },
} as const;

type AppLanguage = keyof typeof SUPPORTED_LANGUAGE_DETAILS;

const DEFAULT_APP_LANGUAGE: AppLanguage = 'en';

const SUPPORTED_LANGUAGES = Object.keys(SUPPORTED_LANGUAGE_DETAILS) as readonly AppLanguage[];

const DEFAULT_NUMBER_FORMATTING_LOCALE = SUPPORTED_LANGUAGE_DETAILS[DEFAULT_APP_LANGUAGE].numberFormattingLocale;

const DEFAULT_DAYJS_LOCALE = SUPPORTED_LANGUAGE_DETAILS[DEFAULT_APP_LANGUAGE].dayjsLocale;

export {
  DEFAULT_APP_LANGUAGE,
  DEFAULT_DAYJS_LOCALE,
  DEFAULT_NUMBER_FORMATTING_LOCALE,
  SUPPORTED_LANGUAGE_DETAILS,
  SUPPORTED_LANGUAGES,
};
export type { AppLanguage };
